module.exports = __webpack_public_path__ + "img/4-2-4-3-4-preview-satoru-e.96630ae2.jpg";